<ex-dropdown-v2 class="category-selector" [class.category-selector--uncategorized]="uncategorized" [value]="value">
  <ng-template exDropdownV2Header let-value let-toggle="toggle" let-open="open">
    <button type="button" class="category-selector__trigger" [class.category-selector__trigger--open]="open" (click)="toggle()">
      @if (value) {
        <span class="category-selector__label">{{ value }}</span>
      } @else {
        <span class="category-selector__placeholder">{{
          (uncategorized ? 'tenders.responses.documents.to-categorize-placeholder' : 'tenders.responses.documents.categorize-placeholder')
            | translate
        }}</span>
      }
      <i class="ph ph-caret-down category-selector__caret" aria-hidden="true"></i>
    </button>
  </ng-template>
  <ng-template exDropdownV2Content let-toggle="toggle">
    <div class="category-selector__menu">
      <app-file-subtype-tag-selector
        [options]="options"
        [value]="value"
        (optionSelected)="onOption($event, toggle)"
        (customSelected)="onCustom($event, toggle)"
      />
    </div>
  </ng-template>
</ex-dropdown-v2>
